module.exports = "query giftCard ($transaction_id: String!) {\n  giftCard (transaction_id: $transaction_id) {\n    gift_card_code\n    gift_card_password\n    status\n    campaign {\n      eventData {\n        rescue_type\n      }\n    }\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/GiftCard.graphql
// module id = 2000
// module chunks = 1611